import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faRightLeft } from "@fortawesome/free-solid-svg-icons";

function CarTransferReport() {
  const { t } = useTranslation();
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: t("car_transfer_report"),
    onBeforeprint: () => {
      document.body.setAttribute("data-printing", "true");
    },
    onAfterPrint: () => {
      document.body.removeAttribute("data-printing");
    },
  });

  const columns = [
    { header: t("brand"), accessor: "car.brand" },
    { header: t("model"), accessor: "car.model" },
    { header: t("chassis_number"), accessor: "car.chassis_number" },
    { header: t("plate_number"), accessor: "car.plate_number" },
    { header: t("from_branch"), accessor: "from_branch.name" },
    { header: t("to_branch"), accessor: "to_branch.name" },
    { header: t("transfer_date"), accessor: "created_at" },
    { header: t("transferred_by"), accessor: "user.name" },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title={t("car_transfer_report")} />

      {/* Print Button */}
      <div className="d-flex justify-content-end mb-3">
        <button
          className="btn btn-primary d-print-none"
          onClick={handlePrint}
        >
          <FontAwesomeIcon icon={faPrint} className="me-2" />
          {t("prints")}
        </button>
      </div>

      {/* Printable Content */}
      <div ref={printRef}>
        <style>{`
          @media print {
            body { background: #fff !important; color: #000 !important; }
            .d-print-none { display: none !important; }
            .print-header { display: block !important; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #333; padding: 8px; text-align: right; }
            th { background-color: #f0f0f0 !important; }
          }
        `}</style>

        {/* Print Header */}
        <div className="print-header d-none mb-4 text-center">
          <h4 className="mb-1">{t("car_transfer_report")}</h4>
          <p className="text-muted small">{new Date().toLocaleDateString("ar-EG")}</p>
          <hr />
        </div>

        <MyTable
          resource="car-transfers"
          columns={columns}
          title={t("car_transfer_report")}
        />
      </div>
    </div>
  );
}

export default CarTransferReport;
